// extracted by mini-css-extract-plugin
export default {"base":"base-A4qFP","item":"item-yGTeF","cycle":"cycle-b4QVU","text":"text-d8ook"};